// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VxE3","question":"styles_question__39F6S","inputVisibleButton":"styles_inputVisibleButton__3Q703","note":"styles_note__2aR-L"};